import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";


import { MenuListPageRoutingModule } from "./menu-list-routing.module";

import { MenuListPage } from "./menu-list.page";
import { MenuCardChunkComponent, MenuCategoryCardsComponent } from "./menu-category-cards.component";
import { CardPageModule } from "../card/card.module";
import { SharedModule } from "../../shared.module";
import { FeaturedCouponPopupComponent } from "../featured-coupon-popup/featured-coupon-popup.component";
import { BodyPortalDirective } from "src/app/shared/directives/body-portal.directive";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		CommonModule,
		FormsModule,
		MenuListPageRoutingModule,
		CardPageModule,
		SharedModule,
		BodyPortalDirective
	],
	declarations: [MenuListPage, MenuCategoryCardsComponent, MenuCardChunkComponent, FeaturedCouponPopupComponent],
	exports: [MenuListPage],
})
export class MenuListPageModule {}
